import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { PatentJpdcExtend } from '../../types';
import type { ApiGetPatentBasicResponse } from '@/infrastructure/api-functions/core-search-api/get-patent-basic-api';
import type { GetPatentJpdcDTO } from '../get-patent-jpdc';

@injectable()
export class GetPatentJpdcDTOImpl implements GetPatentJpdcDTO {
    public getPatentJpdc(data: ApiGetPatentBasicResponse['JPDC_DTERM']): PatentJpdcExtend {
        const result: PatentJpdcExtend = {
            JPDC_DTERM: {},
        };

        try {
            const jpdcDtermList = data.jpdc_dterm || [];
            const jpdcList = data.jpdc || [];
            const dtermList = data.dterm || [];

            // 合并JPDC和Dterm数据
            jpdcList.forEach(item => {
                jpdcDtermList.push({
                    jpdc: item,
                });
            });

            const formattedJpdcDtermList = jpdcDtermList.map(item => ({
                name: item.jpdc,
                dterm: item.dterm || [],
            }));

            if (formattedJpdcDtermList.length) result.JPDC_DTERM.JPDCDtermList = formattedJpdcDtermList;
            if (dtermList.length) result.JPDC_DTERM.dtermList = dtermList;
        } catch (error) {
            console.error(error);
        }

        return result;
    }
}
